<template>
    <div>
        <v-dialog v-model="dialogI" max-width="600px">
        <v-form
          ref="rationForm"
          v-model="dialogI"
          lazy-validation
          @submit.prevent="saveRation"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" dark class="text-h6">
              <div>Edit Ration</div>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <div class="px-5 py-5">
              <v-row>
                <v-col class="py-0" sm="6">
                  <label class="label">Name</label>
                  <v-text-field
                      type="text"
                      outlined
                      placeholder="Enter Ration Name"
                      v-model="ration.name"
                      dense
                    >
                    </v-text-field>
                </v-col>
                <v-col class="py-0" sm="6">
                    <label class="label">
                        Duration
                    </label>
                    <v-select
                      :items="duration"
                      item-text="name"
                      item-value="id"
                      outlined
                      dense
                      placeholder="Select duration"
                      v-model="ration.duration"
                    ></v-select>
                </v-col>
                
              </v-row>
            </div>
            <v-divider></v-divider>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                outlined
                @click="closeModal()"
              >
                Cancel
              </v-btn>

              <v-btn depressed color="primary" type="submit">
                <span>{{ $t("update") }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </div>
  </template>
  <script>
import gql from "graphql-tag";
import loadingMixin from "@/mixins/LoadingMixin";

  export default {
    data() {
      return {
        duration: [
        { id: "1 day", name: "1 day" },
        { id: "2 days", name: "2 days" },
        { id: "3 days", name: "3 days" },
        { id: "4 days", name: "4 days" },
        { id: "5 days", name: "5 days" },
        { id: "6 days", name: "6 days" },
        { id: "7 days", name: "7 days" },
      ],
      };
    },
    props: {
        dialogI: {
            type: Boolean,
            required: true,
        },
        ration: {
            type: Object,
            required: true,
        },
    },
    methods: {
      closeModal() {
        this.$emit("confirmDialog");
      },
      saveRation(){
        this.startLoading();
        const data = {
            id: this.ration.id,
            name: this.ration.name,
            duration: this.ration.duration
        }
        this.$apollo
            .mutate({
                mutation: gql`
            mutation updateRation($updateRationInput: UpdateRationInput!) {
                updateRation(updateRationInput: $updateRationInput)
            }
          `,
          variables: {
            updateRationInput: data,
          },
            }) 
            .then(({ data }) => {
          if (data.updateRation) {
            this.stopLoading();
            this.$notify({
              title: `Successfully updated the status`,
              text: "",
              type: "success",
            });
          }
        })
        .catch(async error => {
          console.log(error);
          this.stopLoading();
        });
        this.$emit("confirmDialog")      
      }
    },
    mixins: [loadingMixin]
  };
  </script>
  
  <style scoped>
  ::v-deep .v-input__control {
    margin: 0 -2px;
    border: 0;
  }
  ::v-deep .v-text-field--enclosed .v-input__append-inner {
    margin-top: 10px;
  }
  </style>
  